/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardSettlementService_Dtos_Common_GenericTaskResponseDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Common_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CashTransferRequestImportService {

    /**
     * @param formData
     * @returns Wealthlane_AwardSettlementService_Dtos_Common_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppCashTransferRequestImportImportCashTransferRequest(
        formData?: {
            File?: Blob;
        },
    ): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_Common_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/cash-transfer-request-import/import-cash-transfer-request',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
